import { TemplateType_Slug, Template } from '@weave/schema-gen-ts/dist/schemas/messaging/templator/v2/model.pb';
import { useTranslation } from '@frontend/i18n';
import { TemplateSelector } from '@frontend/integrated-messaging';
import { useAppScopeStore } from '@frontend/scope';
import { Button, Modal, useModalControl } from '@frontend/design-system';

interface Props {
  onSelectTemplate: (template: Template) => void;
}

export const SelectTemplateButton = ({ onSelectTemplate }: Props) => {
  const { t } = useTranslation('schedule-quick-fill');
  const { selectedLocationIds } = useAppScopeStore();
  const modalControls = useModalControl();

  return (
    <>
      <Button
        iconName='template'
        variant='secondary'
        size='large'
        css={{ marginLeft: 'auto' }}
        {...modalControls.triggerProps}
      ></Button>
      <Modal {...modalControls.modalProps} maxWidth={600}>
        <Modal.Header title={t('Select a Waitlist Template')} onClose={modalControls.closeModal} />
        <Modal.Body>
          <TemplateSelector
            groupIds={selectedLocationIds}
            templateTypes={[TemplateType_Slug.MANUAL_SCHEDULE_QUICK_FILL]}
            onSelectTemplate={(tmpl) => {
              onSelectTemplate(tmpl);
              modalControls.closeModal();
            }}
            onOpenSettings={modalControls.closeModal}
          />
        </Modal.Body>
      </Modal>
    </>
  );
};
